export default "__VITE_ASSET__PR16rtoV__"